// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"9456":"529d0a8243a4edf5","9692":"ac33fff1a79ae64f"}[chunkId] + ".js";
};